'use es6';

import { Record } from 'immutable';
export default Record({
  id: null,
  firstName: null,
  lastName: null,
  email: null,
  hidden: null,
  current: null,
  verified: null
});